import clsx from 'clsx'
import React, { MouseEventHandler } from 'react';

interface ButtonProps {
  primary?: boolean
  backgroundColor?: string
  classname?: string
  size?: 'small' | 'medium' | 'large'
  label?: string
  href?: string
  onClick?: MouseEventHandler,
  style?: 'dark' | 'light' | 'very-light' | 'light-clear'
  disabled?: boolean
  type?: 'button' | 'submit'
  isLoading?: boolean
  children?: React.ReactNode
}

export const Button = ({
  /* eslint-disable-next-line */
  primary = false,
  /* eslint-disable-next-line */
  size = 'small',
  /* eslint-disable-next-line */
  backgroundColor,
  classname,
  label,
  children,
  /* eslint-disable-next-line */
  style,
  type = 'button',
  isLoading = false,
  ...props
}: ButtonProps) => {
  const Component = props.href ? 'a' : 'button'

  return (
    <Component
      type={type}
      className={clsx('button', classname, { 'button--loading': isLoading })}
      style={{ backgroundColor }}
      {...props}>
      <span className='snake' />
      <span className='snake__overlay' />
      {label || children}
    </Component>
  )
}
